import { Segment } from "hp-types";

interface Segmentable {
  segment: string;
}

const splitQuestionsOnSegment = <Type extends Segmentable>(
  questions: Type[]
) => {
  let xyz: Type[] = [];
  let kva: Type[] = [];
  let nog: Type[] = [];
  let dtk: Type[] = [];
  questions.forEach((question) => {
    if (question.segment === Segment.XYZ) {
      xyz = [...xyz, question];
      return;
    }
    if (question.segment === Segment.KVA) {
      kva = [...kva, question];
      return;
    }
    if (question.segment === Segment.NOG) {
      nog = [...nog, question];
      return;
    }
    if (question.segment === Segment.DTK) {
      dtk = [...dtk, question];
      return;
    }
  });
  return {
    xyz,
    kva,
    nog,
    dtk,
  };
};

export default splitQuestionsOnSegment;
